import Z, { useReducer as ye, useCallback as ee, useEffect as M, useState as g, memo as te, useContext as J, useMemo as le, createContext as De } from "react";
import { Spinner as Ee, Autocomplete as Le, Button as k, Icon as N, StatusTag as Ie, Grid as p, Block as pe, Input as D, Select as Se } from "@prometheus/components";
import { SpinnerWidgetContainer as xe, FormElement as A, NAME_COLUMN as ke, SecondaryContentWrapper as fe, FormActionsContainer as _e, ModuleDescriptionCard as Pe, PageList as Ne } from "@prometheus/features";
import { api as v, getSortDirection as we, getReducerWithProduce as Ue, createMethodApiCreateListConfig as Me, createSortingMethodListConfig as Fe, createFiltersPanelListConfig as ze, createCrudMethodsListConfig as We, sortBy as Ge, isEmpty as ue, getUUID as H } from "@prometheus/utils";
import { ModalContext as ge } from "@prometheus/hooks";
import { useNavigate as $e, Routes as Qe, Route as de } from "react-router-dom";
var X = { exports: {} }, w = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var me;
function Ye() {
  if (me) return w;
  me = 1;
  var r = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
  function a(l, c, s) {
    var d = null;
    if (s !== void 0 && (d = "" + s), c.key !== void 0 && (d = "" + c.key), "key" in c) {
      s = {};
      for (var h in c)
        h !== "key" && (s[h] = c[h]);
    } else s = c;
    return c = s.ref, {
      $$typeof: r,
      type: l,
      key: d,
      ref: c !== void 0 ? c : null,
      props: s
    };
  }
  return w.Fragment = n, w.jsx = a, w.jsxs = a, w;
}
var U = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var he;
function qe() {
  return he || (he = 1, process.env.NODE_ENV !== "production" && function() {
    function r(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === Re ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case i:
          return "Fragment";
        case G:
          return "Profiler";
        case C:
          return "StrictMode";
        case L:
          return "Suspense";
        case be:
          return "SuspenseList";
        case Te:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case W:
            return "Portal";
          case z:
            return (e.displayName || "Context") + ".Provider";
          case F:
            return (e._context.displayName || "Context") + ".Consumer";
          case u:
            var o = e.render;
            return e = e.displayName, e || (e = o.displayName || o.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case je:
            return o = e.displayName || null, o !== null ? o : r(e.type) || "Memo";
          case re:
            o = e._payload, e = e._init;
            try {
              return r(e(o));
            } catch {
            }
        }
      return null;
    }
    function n(e) {
      return "" + e;
    }
    function a(e) {
      try {
        n(e);
        var o = !1;
      } catch {
        o = !0;
      }
      if (o) {
        o = console;
        var m = o.error, x = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return m.call(
          o,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          x
        ), n(e);
      }
    }
    function l(e) {
      if (e === i) return "<>";
      if (typeof e == "object" && e !== null && e.$$typeof === re)
        return "<...>";
      try {
        var o = r(e);
        return o ? "<" + o + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function c() {
      var e = $.A;
      return e === null ? null : e.getOwner();
    }
    function s() {
      return Error("react-stack-top-frame");
    }
    function d(e) {
      if (ne.call(e, "key")) {
        var o = Object.getOwnPropertyDescriptor(e, "key").get;
        if (o && o.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function h(e, o) {
      function m() {
        ae || (ae = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          o
        ));
      }
      m.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: m,
        configurable: !0
      });
    }
    function S() {
      var e = r(this.type);
      return se[e] || (se[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function _(e, o, m, x, y, j, Y, q) {
      return m = j.ref, e = {
        $$typeof: O,
        type: e,
        key: o,
        props: j,
        _owner: y
      }, (m !== void 0 ? m : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: S
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(e, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Y
      }), Object.defineProperty(e, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: q
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function b(e, o, m, x, y, j, Y, q) {
      var f = o.children;
      if (f !== void 0)
        if (x)
          if (ve(f)) {
            for (x = 0; x < f.length; x++)
              T(f[x]);
            Object.freeze && Object.freeze(f);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else T(f);
      if (ne.call(o, "key")) {
        f = r(e);
        var P = Object.keys(o).filter(function(Oe) {
          return Oe !== "key";
        });
        x = 0 < P.length ? "{key: someKey, " + P.join(": ..., ") + ": ...}" : "{key: someKey}", ce[f + x] || (P = 0 < P.length ? "{" + P.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          x,
          f,
          P,
          f
        ), ce[f + x] = !0);
      }
      if (f = null, m !== void 0 && (a(m), f = "" + m), d(o) && (a(o.key), f = "" + o.key), "key" in o) {
        m = {};
        for (var V in o)
          V !== "key" && (m[V] = o[V]);
      } else m = o;
      return f && h(
        m,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), _(
        e,
        f,
        j,
        y,
        c(),
        m,
        Y,
        q
      );
    }
    function T(e) {
      typeof e == "object" && e !== null && e.$$typeof === O && e._store && (e._store.validated = 1);
    }
    var E = Z, O = Symbol.for("react.transitional.element"), W = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), C = Symbol.for("react.strict_mode"), G = Symbol.for("react.profiler"), F = Symbol.for("react.consumer"), z = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), L = Symbol.for("react.suspense"), be = Symbol.for("react.suspense_list"), je = Symbol.for("react.memo"), re = Symbol.for("react.lazy"), Te = Symbol.for("react.activity"), Re = Symbol.for("react.client.reference"), $ = E.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ne = Object.prototype.hasOwnProperty, ve = Array.isArray, Q = console.createTask ? console.createTask : function() {
      return null;
    };
    E = {
      react_stack_bottom_frame: function(e) {
        return e();
      }
    };
    var ae, se = {}, oe = E.react_stack_bottom_frame.bind(
      E,
      s
    )(), ie = Q(l(s)), ce = {};
    U.Fragment = i, U.jsx = function(e, o, m, x, y) {
      var j = 1e4 > $.recentlyCreatedOwnerStacks++;
      return b(
        e,
        o,
        m,
        !1,
        x,
        y,
        j ? Error("react-stack-top-frame") : oe,
        j ? Q(l(e)) : ie
      );
    }, U.jsxs = function(e, o, m, x, y) {
      var j = 1e4 > $.recentlyCreatedOwnerStacks++;
      return b(
        e,
        o,
        m,
        !0,
        x,
        y,
        j ? Error("react-stack-top-frame") : oe,
        j ? Q(l(e)) : ie
      );
    };
  }()), U;
}
process.env.NODE_ENV === "production" ? X.exports = Ye() : X.exports = qe();
var t = X.exports;
const Ce = (r) => {
  const { pageNumber: n, pageSize: a, sortBy: l, query: c } = r, s = we(l), d = `/data-sources/list?size=${a || ""}&page=${n || ""}&sort=${s}&${c || ""}`;
  return v.get(d);
}, Ve = (r) => {
  const n = `/data-sources/filter?${r}`;
  return v.get(n);
}, He = () => v.get("/data-sources/dbms-types"), Je = () => v.get("/data-sources/sorts"), Xe = (r) => v.delete(`/data-sources/${r}`), Be = (r, n) => v.put(`/data-sources/${r}`, n), Ke = (r) => v.post("/data-sources", r), Ze = () => v.get("/datanode/centrals/list"), et = (r, n) => v.post(`/data-sources/${r}/publish`, n);
var I = /* @__PURE__ */ ((r) => (r.GET_DATA_SOURCES_REQUEST = "GET_DATA_SOURCES_REQUEST", r.GET_DATA_SOURCES_REQUEST_DONE = "GET_DATA_SOURCES_REQUEST_DONE", r.GET_DATA_SOURCES_REQUEST_FAILED = "GET_DATA_SOURCES_REQUEST_FAILED", r))(I || {}), R = /* @__PURE__ */ ((r) => (r.INITIAL = "INITIAL", r.LOADING_DATA_SOURCES = "LOADING_DATA_SOURCES", r.LOADED_DATA_SOURCES = "LOADED_DATA_SOURCES", r.FAILED_LOADED_DATA_SOURCES = "FAILED_LOADED_DATA_SOURCES", r))(R || {});
const tt = (r, n) => Ue(r, (a) => {
  switch (n.type) {
    case I.GET_DATA_SOURCES_REQUEST:
      a.status = R.LOADING_DATA_SOURCES, a.list = [];
    case I.GET_DATA_SOURCES_REQUEST_DONE:
      a.status = R.LOADED_DATA_SOURCES, a.list = n.payload;
      break;
    case I.GET_DATA_SOURCES_REQUEST_FAILED:
      a.status = R.FAILED_LOADED_DATA_SOURCES, a.list = [], a.error = n.payload;
  }
}), rt = {
  status: R.INITIAL,
  list: [],
  error: null
}, nt = (r) => r.map((n) => ({
  value: n.id,
  name: n.name
})), at = () => {
  const [r, n] = ye(tt, rt), a = ee(async () => {
    n({
      type: I.GET_DATA_SOURCES_REQUEST
    });
    try {
      const l = await Ce({
        pageNumber: 0,
        pageSize: 1e5
      });
      n({
        type: I.GET_DATA_SOURCES_REQUEST_DONE,
        payload: nt(l.content)
      });
    } catch (l) {
      n({
        type: I.GET_DATA_SOURCES_REQUEST_FAILED,
        payload: l
      });
    }
  }, []);
  return M(() => {
    a();
  }, []), {
    ...r
  };
}, st = (r) => {
  const { onChange: n } = r, [a, l] = g(null), { list: c, status: s } = at();
  return M(() => {
    n(a == null ? void 0 : a.value, a);
  }, [a]), s === R.INITIAL || s === R.LOADING_DATA_SOURCES ? /* @__PURE__ */ t.jsx(xe, { children: /* @__PURE__ */ t.jsx(Ee, { size: 32 }) }) : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    s === R.LOADED_DATA_SOURCES && /* @__PURE__ */ t.jsx(A, { name: "data-source", textLabel: "Data sources", children: /* @__PURE__ */ t.jsx(
      Le,
      {
        className: "",
        name: "data-source",
        id: "data-source",
        options: c,
        value: a,
        placeholder: "Select data source...",
        fullWidth: !0,
        isOptionEqualToValue: (d, h) => d.value === h.value,
        onChange: (d, h) => {
          l(h);
        },
        getOptionLabel: (d) => d.name
      }
    ) }),
    s === R.FAILED_LOADED_DATA_SOURCES && /* @__PURE__ */ t.jsx("p", { children: "Failed to load data sources" })
  ] });
}, B = {
  rowId: "id",
  loadingMessage: "Loading data cources...",
  addButtonTitle: "Add Data Source",
  tableTitle: "Data sources",
  importButtonTitle: "Import",
  listInitialSort: null,
  iconName: "dataCatalog",
  createEntityModal: {
    name: "create-cdm",
    title: "Create data source",
    createMethodApi: (r, n) => Me(
      r,
      n,
      Ke
    )
  },
  createCrudMethod: (r, n) => We(
    r,
    n,
    Ce,
    Xe
  ),
  createFiltersPanel: (r, n) => ze(
    null,
    null,
    Ve
  ),
  createSortingMethod() {
    return Fe(null, {
      getSorting: Je
    });
  },
  getCols: (r) => [
    // {
    //   header: 'Id',
    //   accessorKey: 'shortcut',
    //   id: 'id',
    // },
    ke(),
    // {
    //   header: 'Name',
    //   accessorKey: 'name',
    //   id: 'name',
    //   minWidth: 200,
    //   width: '30%',
    //   isCropped: true,
    //   Cell: NameCell,
    // },
    {
      header: "DBMS type",
      accessorKey: "type",
      id: "type",
      width: "10%",
      minSize: 110
    },
    {
      header: "Database",
      accessorKey: "connectionString",
      id: "connectionString",
      minSize: 120,
      maxSize: 240
    },
    {
      header: "CDM schema",
      accessorKey: "cdmSchema",
      id: "cdmSchema",
      size: "5%",
      minWidth: 80
    },
    {
      header: "Model",
      accessorKey: "modelType",
      id: "modelType",
      width: "5%",
      minWidth: 80
    },
    {
      header: "",
      accessorKey: "published",
      id: "published",
      width: "7%",
      minSize: 110,
      cell: (n) => !n.getValue() || n.getValue().length === 0 ? /* @__PURE__ */ t.jsx(
        k,
        {
          size: "small",
          onClick: (a) => {
            a.stopPropagation(), r == null || r.onPublish(n.row.original.id);
          },
          color: "info",
          variant: "outlined",
          startIcon: /* @__PURE__ */ t.jsx(N, { iconName: "publish" }),
          sx: {
            px: 2,
            py: 0.25,
            borderRadius: 0.5,
            fontSize: 12,
            minWidth: 98
          },
          children: "Publish"
        }
      ) : /* @__PURE__ */ t.jsx(Ie, { text: "Published", color: "success" })
    }
  ]
}, ot = (r) => {
  const n = Object.keys(r).map((a) => {
    var l;
    return {
      name: ((l = r[a]) == null ? void 0 : l.label) || a,
      value: a
    };
  });
  return Ge(n, (a) => a.name);
}, K = te((r) => {
  var F, z;
  const {
    afterCreate: n,
    onCancel: a,
    createMethod: l,
    values: c,
    isUpdate: s,
    subModules: d
  } = r, [h, S] = g(!1), [_, b] = g([]), [T, E] = g(), [O, W] = g(), [i, C] = g(
    c || {
      name: "",
      description: "",
      type: "",
      connectionString: "",
      cdmSchema: "",
      resultSchema: "",
      targetSchema: "",
      published: !1,
      credentials: {
        username: "",
        password: ""
      }
    }
  );
  M(() => {
    He().then((u) => {
      b(ot(u)), W(u);
    });
  }, []);
  const G = ee(() => {
    S(!0);
    let u = new FormData();
    u.append(
      "datasource",
      new Blob([JSON.stringify(i)], {
        type: "application/json"
      })
    ), u.append("keyfile", T), s ? Be(c.id, u).then(
      (L) => {
        S(!1), n == null || n(L);
      }
    ) : l(u).then((L) => {
      S(!1), n == null || n(L);
    });
  }, [i, l, T]);
  return /* @__PURE__ */ t.jsx(p, { container: !0, children: /* @__PURE__ */ t.jsx(fe, { children: /* @__PURE__ */ t.jsx(pe, { elevated: !0, outlined: !0, children: /* @__PURE__ */ t.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(A, { name: "name", textLabel: "Name", required: !0, children: /* @__PURE__ */ t.jsx(
      D,
      {
        id: "name",
        name: "name",
        type: "text",
        size: "medium",
        value: i.name,
        onChange: (u) => C({ ...i, name: u.target.value }),
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      A,
      {
        name: "description",
        textLabel: "Description",
        required: !0,
        children: /* @__PURE__ */ t.jsx(
          D,
          {
            id: "description",
            name: "description",
            type: "text",
            size: "medium",
            value: i.description,
            onChange: (u) => C({ ...i, description: u.target.value }),
            fullWidth: !0
          }
        )
      }
    ) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(A, { name: "type", textLabel: "Database type", required: !0, children: /* @__PURE__ */ t.jsx(
      Se,
      {
        className: "",
        name: "type",
        disablePortal: !0,
        id: "type",
        options: _,
        value: i.type,
        placeholder: "Select type...",
        onChange: (u) => {
          C({ ...i, type: u });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      A,
      {
        name: "connectionString",
        textLabel: "Connection string",
        required: !0,
        children: /* @__PURE__ */ t.jsx(
          D,
          {
            id: "connectionString",
            name: "connectionString",
            type: "text",
            size: "medium",
            value: i.connectionString,
            onChange: (u) => C({ ...i, connectionString: u.target.value }),
            fullWidth: !0
          }
        )
      }
    ) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(A, { name: "cdmSchema", textLabel: "CDM schema", children: /* @__PURE__ */ t.jsx(
      D,
      {
        id: "cdmSchema",
        name: "cdmSchema",
        type: "text",
        size: "medium",
        value: i.cdmSchema,
        onChange: (u) => C({ ...i, cdmSchema: u.target.value }),
        fullWidth: !0
      }
    ) }) }),
    i.type === "bigquery" && /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      d.documents,
      {
        type: "component",
        name: "import-json-file",
        subModules: d,
        config: {
          titleButton: "Upload keyfile",
          initialTextFile: c == null ? void 0 : c.keyfileName,
          onChange: (u, L) => {
            E(L);
          }
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(A, { name: "username", textLabel: "Username", required: !0, children: /* @__PURE__ */ t.jsx(
      D,
      {
        id: "username",
        name: "username",
        type: "text",
        size: "medium",
        value: (F = i == null ? void 0 : i.credentials) == null ? void 0 : F.username,
        onChange: (u) => C({
          ...i,
          credentials: {
            ...i == null ? void 0 : i.credentials,
            username: u.target.value
          }
        }),
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(A, { name: "password", textLabel: "Password", required: !0, children: /* @__PURE__ */ t.jsx(
      D,
      {
        id: "password",
        name: "password",
        type: "password",
        size: "medium",
        value: (z = i == null ? void 0 : i.credentials) == null ? void 0 : z.password,
        onChange: (u) => C({
          ...i,
          ...i,
          credentials: {
            ...i.credentials,
            password: u.target.value
          }
        }),
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(A, { name: "schema", textLabel: "Target schema", required: !0, children: /* @__PURE__ */ t.jsx(
      D,
      {
        id: "schema",
        name: "schema",
        type: "text",
        size: "medium",
        value: i.targetSchema,
        onChange: (u) => C({ ...i, targetSchema: u.target.value }),
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      A,
      {
        name: "resultSchema",
        textLabel: "Results schema",
        required: !0,
        children: /* @__PURE__ */ t.jsx(
          D,
          {
            id: "resultSchema",
            name: "resultSchema",
            type: "text",
            size: "medium",
            value: i.resultSchema,
            onChange: (u) => C({ ...i, resultSchema: u.target.value }),
            fullWidth: !0
          }
        )
      }
    ) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(_e, { children: [
      /* @__PURE__ */ t.jsx(
        k,
        {
          variant: "outlined",
          disabled: h,
          onClick: a,
          startIcon: /* @__PURE__ */ t.jsx(N, { iconName: "deactivate" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        k,
        {
          disabled: h || ue(i.name) || ue(i.type),
          onClick: G,
          variant: "contained",
          color: "success",
          startIcon: /* @__PURE__ */ t.jsx(N, { iconName: "submit" }),
          children: "Save"
        }
      )
    ] }) })
  ] }) }) }) });
}), it = ({ subModules: r }) => {
  const n = $e(), { openModal: a, closeModal: l } = J(ge), { createEntityModal: c } = B, s = Z.useMemo(() => c.createMethodApi(null, null), []), d = () => {
    a(
      () => /* @__PURE__ */ t.jsx(
        K,
        {
          createMethod: s == null ? void 0 : s.create,
          onCancel: l,
          afterCreate: (h) => {
            l(), n("/cdm-source-list");
          },
          subModules: r
        }
      ),
      c.title,
      {
        closeOnClickOutside: !0,
        onClose: l,
        width: 700
      }
    );
  };
  return /* @__PURE__ */ t.jsx(
    Pe,
    {
      title: "Data sources",
      onClick: () => n("/cdm-source-list"),
      description: "List of data sources.",
      iconName: "dataCatalog",
      actions: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx(
          k,
          {
            onClick: () => d(),
            variant: "contained",
            color: "success",
            name: "save",
            startIcon: /* @__PURE__ */ t.jsx(N, { iconName: "add" }),
            children: "Add data source"
          }
        ),
        /* @__PURE__ */ t.jsx(
          k,
          {
            onClick: () => n("/cdm-source-list"),
            variant: "outlined",
            name: "save",
            sx: { ml: 1 },
            children: "View all"
          }
        )
      ] })
    }
  );
}, ct = te((r) => {
  const { name: n, config: a, ...l } = r;
  return /* @__PURE__ */ t.jsxs(Z.Fragment, { children: [
    n === "data-sources-list-select" && /* @__PURE__ */ t.jsx(st, { onChange: a == null ? void 0 : a.onChange }),
    n === "home-widget" && /* @__PURE__ */ t.jsx(it, { subModules: l.subModules })
  ] });
}), lt = te((r) => {
  const { dataSourceId: n, onCancel: a, onPublish: l, createMethod: c } = r, [s, d] = g(!1), [h, S] = g([]), [_, b] = g({
    centralIds: []
  }), T = ee(async () => {
    d(!0);
    try {
      const E = await c(n, {
        centralId: _.centralIds[0]
      });
      l(), d(!1);
    } catch {
    }
  }, [_]);
  return M(() => {
    Ze().then((E) => {
      S(
        E.content.map((O) => ({
          value: O.id,
          name: O.address
        }))
      );
    });
  }, []), /* @__PURE__ */ t.jsx(p, { container: !0, p: 2, children: /* @__PURE__ */ t.jsx(fe, { children: /* @__PURE__ */ t.jsx(pe, { children: /* @__PURE__ */ t.jsxs(p, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(A, { name: "type", textLabel: "Centrals", required: !0, children: /* @__PURE__ */ t.jsx(
      Se,
      {
        className: "",
        name: "type",
        disablePortal: !0,
        id: "type",
        options: h,
        value: _.centralIds,
        placeholder: "Select central...",
        multiple: !0,
        onChange: (E) => {
          b({
            ..._,
            centralIds: [E]
          });
        },
        fullWidth: !0
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(p, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(_e, { children: [
      /* @__PURE__ */ t.jsx(
        k,
        {
          variant: "outlined",
          disabled: s,
          onClick: a,
          size: "small",
          startIcon: /* @__PURE__ */ t.jsx(N, { iconName: "deactivate" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        k,
        {
          disabled: s || _.centralIds.length == 0,
          onClick: T,
          variant: "contained",
          size: "small",
          color: "success",
          startIcon: /* @__PURE__ */ t.jsx(N, { iconName: "submit" }),
          children: "Publish data source"
        }
      )
    ] }) })
  ] }) }) }) });
}), ut = () => {
  const { openModal: r, closeModal: n } = J(ge), [a, l] = g(), c = J(
    Ae
  ), s = le(() => c == null ? void 0 : c.config, []), { createEntityModal: d, getCols: h } = B, S = le(() => d.createMethodApi(
    s == null ? void 0 : s.typeContainer,
    s == null ? void 0 : s.parentId
  ), [s == null ? void 0 : s.typeContainer, s == null ? void 0 : s.parentId]), _ = (E) => {
    r(
      () => /* @__PURE__ */ t.jsx(
        lt,
        {
          dataSourceId: E,
          onCancel: n,
          createMethod: et,
          onPublish: (O) => {
            l(H()), n();
          }
        }
      ),
      "Publish data source",
      {
        closeOnClickOutside: !0,
        onClose: n
      }
    );
  }, b = () => {
    r(
      () => /* @__PURE__ */ t.jsx(
        K,
        {
          createMethod: S == null ? void 0 : S.create,
          subModules: c.subModules,
          onCancel: n,
          afterCreate: (E) => {
            n(), l(H());
          }
        }
      ),
      d.title,
      {
        closeOnClickOutside: !0,
        onClose: n
      }
    );
  }, T = (E) => {
    r(
      () => /* @__PURE__ */ t.jsx(
        K,
        {
          createMethod: S == null ? void 0 : S.create,
          subModules: c.subModules,
          onCancel: n,
          values: E.original,
          isUpdate: !0,
          afterCreate: (O) => {
            l(H()), n();
          }
        }
      ),
      "Update data source",
      {
        closeOnClickOutside: !0,
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ t.jsx(
    Ne,
    {
      reloadId: a,
      isImport: !1,
      isCreate: !0,
      onCreate: b,
      moduleConfig: c,
      listConfig: {
        ...B,
        cols: h({
          onPublish: _
        })
      },
      onRowClick: T,
      variant: "primary",
      allowDelete: !0
    }
  );
}, dt = () => /* @__PURE__ */ t.jsx(t.Fragment, { children: "Entity" }), Ae = De(null), mt = (r) => {
  const { path: n, title: a, name: l, storage: c, rootSettings: s, initStorage: d } = r, [h, S] = g(s), [_, b] = g(!0);
  return M(() => {
    s || S({
      rootPath: n,
      rootTitle: a
    }), b(!1);
  }, []), _ ? /* @__PURE__ */ t.jsx(xe, { children: /* @__PURE__ */ t.jsx(Ee, { size: 32 }) }) : /* @__PURE__ */ t.jsx(Ae.Provider, { value: { ...r, rootSettings: h }, children: /* @__PURE__ */ t.jsxs(Qe, { children: [
    /* @__PURE__ */ t.jsx(de, { index: !0, element: /* @__PURE__ */ t.jsx(ut, {}) }),
    /* @__PURE__ */ t.jsx(de, { path: ":id/*", element: /* @__PURE__ */ t.jsx(dt, {}) })
  ] }) });
}, gt = (r) => {
  const { type: n } = r;
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    !n && /* @__PURE__ */ t.jsx(mt, { ...r }),
    n === "component" && /* @__PURE__ */ t.jsx(ct, { ...r })
  ] });
};
var ht = /* @__PURE__ */ ((r) => (r.POSTGRE_SQL = "PostgreSQL", r.MS_SQL_SERVER = "MS SQL Server", r.SQL_SERVER_PARALLEL = "SQL Server Parallel Data Warehouse", r.GOOGLE_BIG_QUERY = "Google BigQuery", r.NETEZZA = "Netezza", r.SPARK = "Spark", r.ORACLE = "Oracle", r.IMPALA = "Impala", r.RED_SHIFT = "Redshift", r.APACHE_HIVE = "Apache Hive", r))(ht || {});
export {
  gt as CdmDataSources,
  ht as DBMSType
};
//# sourceMappingURL=cdm-data-sources.js.map
